var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.589,
    height: 16.068,
    viewBox: "0 0 15.589 16.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28082",
    "data-name": "Group 28082",
    transform: "translate(-712 -510)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33831",
    "data-name": "Path 33831",
    d: "M6156-1681v7.521l4.273,4.274h7.042l4.273-4.274V-1681l-4.273-4.274h-7.042Z",
    transform: "translate(-5444 2195.276)",
    fill: "#e95f47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": " \\u21B3Color",
    d: "M7.339.739,6.6,0,3.67,2.93.739,0,0,.739,2.93,3.67,0,6.6l.739.739,2.93-2.93L6.6,7.339,7.339,6.6,4.409,3.67Z",
    transform: "translate(715.962 513.962)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportError);
export default __webpack_public_path__ + "static/media/report-error.916fcdc1448426f928cf57f841302289.svg";
export { ForwardRef as ReactComponent };